import React from 'react';
import { EyeInvisibleOutlined } from "@ant-design/icons";
import { Tag } from "antd";

interface HiddenTagInterface {
  hidden: boolean;
  text?: string;
}

export const HiddenTag = ({ hidden, text = 'Hidden' }: HiddenTagInterface) => {
  if (hidden) {
    return <Tag color='default' icon={<EyeInvisibleOutlined/>}>{text}</Tag>;
  } else {
    return null;
  }
}

